import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";

const Dropdown = ({ options, label, name, value, onChange, showSelect = true, required = false, sx = {}, }) => {
    const labelId = `${name}-label`;

    return (
        <FormControl fullWidth required={required}>
            <InputLabel id={labelId}>
                {label}
                {required}
            </InputLabel>

            <Select
                labelId={labelId}
                label={label}
                name={name}
                value={value}
                onChange={onChange}
                sx={{ backgroundColor: "#e8f2ec " }}
            >
                {showSelect && (
                    <MenuItem key="select-placeholder" value="">
                        Select
                    </MenuItem>
                )
                }
                {options?.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl >
    );
};

export default Dropdown;
